export default {
	"accountSettings.title": "账户设置",
	"accountSettings.email.label": "Email",
	"accountSettings.username.label": "用户名",
	"accountSettings.username.button.save": "保存",
	"accountSettings.username.button.cancel": "取消",
	"accountSettings.username.message.failed": "用户名最大长度为20",
	"accountSettings.password.label": "密码",
	"accountSettings.password.button.change": "修改密码",
	"accountSettings.password.modal.title": "修改密码",
	"accountSettings.password.modal.label.original": "原密码",
	"accountSettings.password.modal.label.new": "新密码",
}
